import { render, staticRenderFns } from "./SettingsCarpoolingDetails.vue?vue&type=template&id=1368a78a&scoped=true&"
import script from "./SettingsCarpoolingDetails.vue?vue&type=script&lang=js&"
export * from "./SettingsCarpoolingDetails.vue?vue&type=script&lang=js&"
import style0 from "./SettingsCarpoolingDetails.vue?vue&type=style&index=0&id=1368a78a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1368a78a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\carli\\Documents\\Github\\Sharo Employee New\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1368a78a')) {
      api.createRecord('1368a78a', component.options)
    } else {
      api.reload('1368a78a', component.options)
    }
    module.hot.accept("./SettingsCarpoolingDetails.vue?vue&type=template&id=1368a78a&scoped=true&", function () {
      api.rerender('1368a78a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Settings/SettingsCarpoolingDetails.vue"
export default component.exports